import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { getContentList } from '../utils/getContent';

import logo_app_black from "../images/logo_app_black.png";

export default function QMobViagem() {
  const { t, i18n } = useTranslation();
  const [content, setContent] = useState(null);

  useEffect(() => {
    getContentList('q-mob-q-mob-viagem', i18n.language.split('-')[0]).then((data) => {
      setContent(data);
    });
  }, [i18n.language.split('-')[0]]);

  const handleClickAppLogo = () => {
     window.open(
      "https://storage.googleapis.com/wgs-prd/qmob/app/app-qmob-stg.apk",
      "_blank"
    );
  };
  
  return (
    <div className="container p-lg-5">
      {content && (<h3 className="display-5 mb-3">{content.data.Titulo}</h3>)}
      <a className="navbar-brand" onClick={handleClickAppLogo} style={{ cursor: 'pointer' }}>
        <img class="mb-3" src={logo_app_black} style={{ height: 150 }} />
      </a>
      <p>
        {content && (<span
          dangerouslySetInnerHTML={{
            __html: content.data.Texto
          }}
        ></span>)}
      </p>
    </div>
  );
}

/*
import { h, Fragment } from "preact";
import Parser from "html-react-parser";
import { useTranslation } from "react-i18next";
import React from 'react';

import {
  LANGUAGE_EN_CODE,
  LANGUAGE_ES_CODE,
  LANGUAGE_PT_CODE,
} from "../utils/constants";
import useContentfulContent from "../hooks/useContentfulContent";
import ContentPage from "../components/ContentPage";
import ContactForm from "../components/ContactForm";

const PAGE_ID_BY_LANG = {
  [LANGUAGE_PT_CODE]: "3eUsQfkdQdZrMKbdEZbOUj",
  [LANGUAGE_EN_CODE]: "2br17kCNWCZVHWcWZAplYX",
  [LANGUAGE_ES_CODE]: "3bLQAY8NcJtfumsgWUt9Cn",
};

export default function Contacts() {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.resolvedLanguage;
  const pageId = PAGE_ID_BY_LANG[currentLang];

  const { title, content } = useContentfulContent(pageId);

  const _renderContent = () => (
    <Fragment>
      {Parser(content)}
      
    </Fragment>
  )

  return (
    <ContentPage title={title} content={_renderContent()} />
  );
}*/